import { logout } from 'actionCreators/auth';
import { setError } from 'actionCreators/error';
import axios, { AxiosRequestConfig, AxiosInstance } from 'axios';
import { API_BASE_URL_FORUM, BUILD_NUMBER } from 'settings';

import { getStore } from '../redux/store';
import tokenService from './token';

const instance: AxiosInstance = axios.create();

instance.interceptors.request.use(
  async function (config) {
    try {
      const authToken = await tokenService.getToken();
      return {
        ...config,
        headers: {
          ...config.headers,
          Authorization: authToken ? `Bearer ${authToken}` : '',
          FrontVersion: BUILD_NUMBER || 'local',
        },
      };
    } catch (error) {
      //Cancelling request
      return {
        headers: {},
        method: config.method,
        url: '',
      };
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const { dispatch } = getStore();
    if (!error.response) {
      dispatch(setError(504));
    } else if (error.response.status === 401) {
      logout();
    }
    const statusCode = error.response.status;
    const requestError = { status: statusCode, message: error.response.data.error };
    return Promise.reject(requestError);
  }
);

export const get = (props: AxiosRequestConfig) =>
  instance({
    ...props,
    method: 'get',
    url: API_BASE_URL_FORUM + props.url,
  });

export const post = (props: AxiosRequestConfig) =>
  instance({
    ...props,
    method: 'post',
    url: API_BASE_URL_FORUM + props.url,
  });

export const put = (props: AxiosRequestConfig) =>
  instance({
    ...props,
    method: 'put',
    url: API_BASE_URL_FORUM + props.url,
  });

export const del = (props: AxiosRequestConfig) =>
  instance({
    ...props,
    method: 'delete',
    url: API_BASE_URL_FORUM + props.url,
  });
